import React, { useEffect, useState } from 'react';
import api from '../services/api';
import tmdb from '../services/tmdb';
import AdminMenu from '../components/AdminMenu';
import './AdminPeticiones.css';

function AdminPeticiones() {
  const [peticiones, setPeticiones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('sin-completar');
  const [detalles, setDetalles] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [serieSeleccionada, setSerieSeleccionada] = useState(null);

  useEffect(() => {
    const fetchPeticiones = async () => {
      try {
        const token = localStorage.getItem('token'); // Obtén el token del almacenamiento local
        
        const response = await api.get('/peticiones/agrupadas', {
          headers: {
            Authorization: `Bearer ${token}`,  // Pasa el token aquí
          },
        });
        
        setPeticiones(response.data);
      } catch (err) {
        setError('No se pudieron cargar las peticiones');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPeticiones();
  }, []);
  

  const updatePeticionEstado = async (id, estado) => {
    try {
      // Verifica que el estado sea válido antes de hacer la petición
      const estadosValidos = ['pendiente', 'en-proceso', 'completada', 'rechazada'];
      if (!estadosValidos.includes(estado)) {
        throw new Error('Estado no válido');
      }
  
      const response = await api.patch(`/peticiones/${id}/estado`, { estado }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
  
      if (response.status === 200) {
        setPeticiones(prev =>
          prev.map(p => p.id === id ? { ...p, estado } : p)
        );
        console.log('Estado actualizado correctamente');
      } else {
        throw new Error(response.data.message || 'Error al actualizar el estado');
      }
    } catch (error) {
      console.error('Error en updatePeticionEstado:', error);
      alert(`Error: ${error.message || 'Error de red al actualizar el estado'}`);
      
      // Muestra más detalles del error si está disponible
      if (error.response) {
        console.error('Detalles del error:', error.response.data);
      }
    }
  };

  const eliminarPeticion = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar esta petición?')) return;
    try {
      await api.delete(`/peticiones/${id}`);
      setPeticiones(prev => prev.filter(p => p.id !== id));
    } catch {
      alert('Error al eliminar la petición');
    }
  };

  const toggleExpand = async (peticion) => {
    if (peticion.tipo === 'serie') {
      setSerieSeleccionada(peticion);
      setModalVisible(true);
      
      if (!detalles[peticion.id]) {
        try {
          let tmdbId = peticion.tmdb_id;
          if (!tmdbId && peticion.titulo) {
            const res = await tmdb.buscarContenido(peticion.titulo);
            const match = res.find(r =>
              (r.title === peticion.titulo || r.name === peticion.titulo) &&
              (r.release_date?.includes(peticion.year) || r.first_air_date?.includes(peticion.year))
            );
            tmdbId = match?.id;
          }

          if (tmdbId) {
            const info = await tmdb.obtenerDetallesCompleto(tmdbId, peticion.tipo);
            setDetalles(prev => ({ ...prev, [peticion.id]: info }));
          }
        } catch (err) {
          console.error('Error al cargar detalles TMDB', err);
        }
      }
    } else {
      // Para películas, mantener el comportamiento actual
      if (detalles[peticion.id]) {
        setDetalles(prev => ({ ...prev, [peticion.id]: null }));
      } else {
        try {
          let tmdbId = peticion.tmdb_id;
          if (!tmdbId && peticion.titulo) {
            const res = await tmdb.buscarContenido(peticion.titulo);
            const match = res.find(r =>
              r.title === peticion.titulo && 
              r.release_date?.includes(peticion.year)
            );
            tmdbId = match?.id;
          }

          if (tmdbId) {
            const info = await tmdb.obtenerDetallesCompleto(tmdbId, peticion.tipo);
            setDetalles(prev => ({ ...prev, [peticion.id]: info }));
          }
        } catch (err) {
          console.error('Error al cargar detalles TMDB', err);
        }
      }
    }
  };

  const toggleCapitulos = (temporada) => {
    setDetalles(prev => ({
      ...prev,
      [serieSeleccionada.id]: {
        ...prev[serieSeleccionada.id],
        temporadasDesplegadas: {
          ...prev[serieSeleccionada.id]?.temporadasDesplegadas,
          [temporada]: !prev[serieSeleccionada.id]?.temporadasDesplegadas?.[temporada]
        }
      }
    }));
  };

  const filtered = peticiones.filter(p =>
    filter === 'all' ? true :
    filter === 'sin-completar' ? p.estado !== 'completada' :
    p.estado === filter
  );
  
  if (loading) return <div className="loading">Cargando...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <AdminMenu />
      <div className="admin-peticiones" style={{ paddingTop: 80 }}>
      <div className="header">
        <h2>📥 Peticiones</h2>
        <select value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">Todas</option>
          <option value="pendiente">Pendientes</option>
          <option value="en-proceso">En proceso</option>
          <option value="completada">Completadas</option>
          <option value="rechazada">Rechazadas</option>
          <option value="sin-completar">Sin completar</option>
        </select>
      </div>
      
      <ul className="lista-horizontal">
        {filtered.map(p => (
          <li key={p.id} className={`peticion-linea ${p.estado}`} onClick={() => toggleExpand(p)}>
            <div className="linea-info">
              <span className="tipo">{p.tipo === 'serie' ? '📺' : '🎬'}</span>
              <strong>{p.titulo}</strong> ({p.year})
              <span className={`estado ${p.estado}`}>[{p.estado}]</span>

              <button
                className="btn-eliminar-texto"
                onClick={(e) => {
                  e.stopPropagation();
                  eliminarPeticion(p.id);
                }}
              >
                Eliminar
              </button>
            </div>

            <div className="perfiles">
              <strong>Perfiles:</strong>{" "}
              {p.perfiles && p.perfiles.map((perfil, i) => (
                <span key={i}>👤 {perfil.username} ({perfil.nombre}){i < p.perfiles.length - 1 ? ', ' : ''}</span>
              ))}
            </div>

            {p.tipo === 'pelicula' && detalles[p.id] && (
              <div className="detalle-expandido">
                <img
                  src={`https://image.tmdb.org/t/p/w185${detalles[p.id].poster_path}`}
                  alt={p.titulo}
                  className="caratula-mini"
                />
                <div className="descripcion">
                  <p><strong>Observaciones:</strong> {p.observaciones}</p>
                  <p><strong>Sinopsis:</strong> {detalles[p.id].overview}</p>
                  <p><strong>Actores:</strong> {detalles[p.id].credits?.cast?.slice(0, 5).map(a => a.name).join(', ')}</p>
                </div>
              </div>
            )}

            <select
              value={p.estado}
              onClick={e => e.stopPropagation()}
              onChange={(e) => updatePeticionEstado(p.id, e.target.value)}
            >
              <option value="pendiente">Pendiente</option>
              <option value="en-proceso">En proceso</option>
              <option value="completada">Completada</option>
              <option value="rechazada">Rechazada</option>
            </select>
          </li>
        ))}
      </ul>

      {/* Modal para series */}
      {modalVisible && serieSeleccionada && (
        <div className="modal-series">
          <div className="modal-contenido">
            <button className="cerrar-modal" onClick={() => setModalVisible(false)}>×</button>
            
            <div className="modal-header">
              <h3>{serieSeleccionada.titulo} ({serieSeleccionada.year})</h3>
              {detalles[serieSeleccionada.id]?.poster_path && (
                <img
                  src={`https://image.tmdb.org/t/p/w185${detalles[serieSeleccionada.id].poster_path}`}
                  alt={serieSeleccionada.titulo}
                  className="modal-poster"
                />
              )}
            </div>

            <div className="modal-body">
              {detalles[serieSeleccionada.id]?.overview && (
                <p className="sinopsis"><strong>Sinopsis:</strong> {detalles[serieSeleccionada.id].overview}</p>
              )}

<div className="temporadas-container">
  <h4>Temporadas solicitadas:</h4>
  {(() => {
    // 1. Unimos todos los episodios pedidos por todos los perfiles
    const todosEpisodios = (serieSeleccionada.perfiles || []).flatMap(p => p.episodios || []);
    
    // 2. Agrupamos por temporada
    const temporadasMap = {};
    for (const ep of todosEpisodios) {
      const [temp, cap] = ep.split('-').map(Number);
      if (!temporadasMap[temp]) temporadasMap[temp] = new Set();
      temporadasMap[temp].add(cap);
    }

    // 3. Devolvemos el array de temporadas ordenado
    return Object.entries(temporadasMap)
      .sort((a, b) => a[0] - b[0])
      .map(([temporada, capsSet]) => {
        const capitulos = Array.from(capsSet).sort((a, b) => a - b);
        const totalCapitulos = detalles[serieSeleccionada.id]?.seasons?.find(s => s.season_number === parseInt(temporada))?.episode_count || '?';

        return (
          <div key={temporada} className="temporada-item">
            <div 
              className="temporada-header"
              onClick={() => toggleCapitulos(temporada)}
            >
              <span>Temporada {temporada}</span>
              <span className="estado-temporada">
                ({capitulos.length}/{totalCapitulos})
              </span>
            </div>

            {detalles[serieSeleccionada.id]?.temporadasDesplegadas?.[temporada] && (
              <div className="capitulos-lista">
                {capitulos.map(cap => (
                  <span key={cap} className="capitulo-item">Episodio {cap}</span>
                ))}
              </div>
            )}
          </div>
        );
      });
  })()}
</div>



              <div className="perfiles-solicitantes">
                <h4>Perfiles que solicitaron:</h4>
                {serieSeleccionada.perfiles?.map((perfil, i) => (
                  <div key={i} className="perfil-item">
                    👤 {perfil.username} ({perfil.nombre})
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </>  
  );
}

export default AdminPeticiones;